import { Injectable } from '@angular/core';
import type { GraphQLParams, PriorityRank } from '@tag/graphql';
import { Query, gql } from 'apollo-angular';
import { config } from '@tag/graphql';

export interface Response {
  priorityRanks: { items: PriorityRank[]; totalCount: number };
}

@Injectable({
  providedIn: 'root',
})
export class PriorityRanksGQL extends Query<
  Response,
  GraphQLParams<'priorityRank'>
> {
  document = gql(config.priorityRank.query);
}
